module.exports = __webpack_public_path__ + "img/vector.b8edc18e.svg";